import request from "@/utils/request"
// 获取升级包列表
export function getUpgradePackagePageList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/UpgradePackage/GetPageList",
    method: "get",
    params
  })
}
// 修改升级包
export function modifyUpgradePackage(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/UpgradePackage/Update",
    method: "post",
    data
  })
}
// 删除升级包
export function delUpgradePackage(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/UpgradePackage/Delete",
    method: "post",
    data
  })
}
// 新增升级包
export function addUpgradePackage(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/UpgradePackage/Add",
    method: "post",
    data
  })
}

// 获取可升级设备列表（分页）
export function getOnlineDevicesForUpgrade(data) {
  return request({
    url: '/Anno.Plugs.DevArchive/UpgradePackage/GetOnlineDeviceListForUpgrade',
    method: 'post',
    data
  })
}

// 执行远程升级
export function upgradeDevice(data) {
  return request({
    url: '/Anno.Plugs.DevArchive/UpgradePackage/UpgradeDevice',
    method: 'post',
    data
  })
}